import { useEffect, useState } from 'react';

/**
 * A phone in either orientation, or a small tablet held upright: a touch-first device narrower than
 * Bootstrap's lg breakpoint. A desktop with a touch screen still reports a fine primary pointer.
 */
export const MOBILE_VIEWPORT_QUERY = '(max-width: 991.98px) and (pointer: coarse)';

const mediaQueryOf = (): MediaQueryList | null =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(MOBILE_VIEWPORT_QUERY)
    : null;

/** True on a mobile device; follows rotation and window resizes. False wherever media queries are unavailable. */
export const useMobileViewport = (): boolean => {
  const [mobile, setMobile] = useState(() => mediaQueryOf()?.matches ?? false);

  useEffect(() => {
    const query = mediaQueryOf();
    if (!query) {
      return undefined;
    }
    const sync = () => setMobile(query.matches);
    sync();
    query.addEventListener('change', sync);
    return () => query.removeEventListener('change', sync);
  }, []);

  return mobile;
};
